"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decode = void 0;
var helper_1 = require("./helper");
var validate_1 = require("./validate");
/**
 * Takes in a deckCode. Spits out a list of libraryIds, domain, and formatCode.
 * @param deckCode
 */
function decode(deckCode) {
    if (!validate_1.validate(deckCode)) {
        throw new Error("deckCode is not valid.");
    }
    var _a = deckCode.split("_"), headerCode = _a[0], formatCode = _a[1], domainCode = _a[2], encodedLibraryIds = _a[3], rest = _a.slice(4);
    var domain = helper_1.decodeDomain(+domainCode);
    var format = +formatCode;
    var encodedLibraryIdChunks = helper_1.chunkString(encodedLibraryIds, 3);
    var libraryIds = encodedLibraryIdChunks === null || encodedLibraryIdChunks === void 0 ? void 0 : encodedLibraryIdChunks.map(function (x) { return helper_1.decodeLibraryId(x); });
    return {
        libraryIds: libraryIds,
        domain: domain,
        formatCode: format,
    };
}
exports.decode = decode;
